import * as React from "react";
const LogoBigColor = (props) => (
    <svg
        width={142}
        height={32}
        viewBox="0 0 142 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#a)">
            <g clipPath="url(#b)">
                <path
                    d="m8.485 20.602-2.107.08-.068.8.391.976 1.079 6.378h.94zm8.953-.809-2.1.224.63 1.564.63 6.931h.84z"
                    fill="#008C95"
                />
                <path
                    d="M20.28 13.592 32 27.112h-8.114l-6.535-6.535-11.042.901.451-9.239H0l3.155-3.605L8.789 3z"
                    fill="#008C95"
                />
                <path
                    d="M8.073 7.09c-1.292.322-2.799 1.533-2.906 1.856.35.457 2.357 1.356 3.713 1.292 1.357-.065 2.96-1.265 3.391-1.777-.726-.484-2.906-1.695-4.198-1.372"
                    fill="#fff"
                />
                <path
                    d="M9.607 8.41c0 .58-1.027 1.534-1.696 1.534-.668 0-1.614-.712-1.614-1.292S7 7.2 7.669 7.2s1.938.632 1.938 1.211"
                    fill="#008C95"
                />
            </g>
            <path
                d="M35.32 27V9.545h12.171v3.427h-7.952v3.58h7.33v3.434h-7.33v3.588h7.952V27zm27.512-13.09L58.34 27h-4.772l-4.483-13.09h4.389l2.412 9.016h.136l2.42-9.017zm7.295 13.337q-2.053 0-3.545-.81a5.6 5.6 0 0 1-2.284-2.326q-.793-1.518-.793-3.605 0-2.029.801-3.546a5.8 5.8 0 0 1 2.259-2.37q1.457-.85 3.435-.851 1.397 0 2.556.434 1.159.435 2.003 1.287t1.313 2.105q.468 1.245.468 2.855v1.04H64.963v-2.42h7.5a2.35 2.35 0 0 0-.316-1.185 2.14 2.14 0 0 0-.844-.81 2.44 2.44 0 0 0-1.218-.298q-.7 0-1.253.316-.555.306-.878.843-.325.529-.34 1.202v2.463q0 .801.314 1.406.316.597.895.93.58.331 1.381.332.555 0 1.006-.154t.775-.451q.324-.3.486-.733l3.827.11a4.73 4.73 0 0 1-1.049 2.242q-.8.946-2.105 1.474-1.304.52-3.017.52m12.51-7.713V27h-4.168V13.91h3.963v2.403h.145a3.68 3.68 0 0 1 1.483-1.884q1.048-.69 2.497-.69 1.38 0 2.395.622a4.15 4.15 0 0 1 1.585 1.721q.57 1.1.563 2.574V27h-4.168v-7.526q.009-1.09-.554-1.704-.554-.614-1.543-.614-.655 0-1.159.29a1.9 1.9 0 0 0-.767.81q-.264.528-.272 1.278m18.432-5.625v3.068h-8.258V13.91zm-6.528-3.136h4.167v12.11q0 .384.12.623a.75.75 0 0 0 .366.332q.24.094.571.094.24 0 .503-.043.273-.05.409-.085l.631 3.009q-.298.084-.844.213-.537.127-1.287.162-1.466.067-2.514-.341-1.04-.418-1.594-1.296-.546-.877-.528-2.207zm17.101 10.576v-7.44h4.159V27h-3.972v-2.437h-.136a3.8 3.8 0 0 1-1.483 1.909q-1.04.698-2.514.698-1.34 0-2.353-.613a4.2 4.2 0 0 1-1.576-1.713q-.563-1.109-.571-2.591v-8.344h4.167v7.526q.008 1.065.563 1.679.554.613 1.508.613.622 0 1.117-.273.503-.28.792-.81.299-.536.299-1.295m6.811 10.56v-18h4.125v2.242h.128q.256-.597.725-1.151a3.6 3.6 0 0 1 1.21-.903q.741-.358 1.773-.358 1.363 0 2.548.715 1.192.717 1.926 2.208.733 1.491.733 3.801 0 2.224-.707 3.724-.7 1.5-1.892 2.25-1.185.75-2.634.75-.989 0-1.713-.323a3.7 3.7 0 0 1-1.219-.853 4.1 4.1 0 0 1-.75-1.133h-.085v7.031zm4.083-11.454q0 1.056.281 1.84.29.785.827 1.22.545.425 1.304.425.767 0 1.304-.426.536-.435.809-1.218.282-.785.282-1.841t-.282-1.833q-.273-.776-.809-1.201-.529-.427-1.304-.427-.767 0-1.304.418-.537.417-.827 1.193-.282.776-.281 1.85"
                fill="#008C95"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h142v32H0z" />
            </clipPath>
            <clipPath id="b">
                <path fill="#fff" d="M0 0h32v32H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default LogoBigColor;
